import { SiFacebook, SiInstagram, SiYoutube, SiSpotify, SiApplemusic } from 'react-icons/si';
import logo from '../assets/logo.png';
import { BandsInTownWidget } from './BandsInTownWidget';
import { ContactCTA } from './ContactCTA';
import { getCloudinaryUrl } from '../utils/cloudinary';

export function HomePage() {
    return (
        <div className="w-full">
            {/* Hero Section */}
            <div
                className="relative w-full h-[600px] md:h-[700px] bg-cover bg-center"
                style={{
                    backgroundImage: `url('${getCloudinaryUrl('band-northwoods-1.jpg', { width: 1920, quality: 'auto' })}')`,
                }}
            >
                {/* Dark overlay for readability */}
                <div className="absolute inset-0 bg-black/70"></div>

                {/* Content */}
                <div className="relative h-full flex flex-col items-center justify-center px-4 gap-6">
                    <img src={logo} alt="Samuel John Band" className="w-full max-w-sm md:max-w-md" />

                    {/* Social Links */}
                    <div className="flex gap-6">
                        <a
                            href="https://www.facebook.com/SamuelJohnMusician/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-primary transition-colors"
                        >
                            <SiFacebook className="w-7 h-7" />
                        </a>
                        <a
                            href="https://www.instagram.com/samuel.john.music/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-primary transition-colors"
                        >
                            <SiInstagram className="w-7 h-7" />
                        </a>
                        <a
                            href="https://www.youtube.com/@SamuelJohnBand"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-primary transition-colors"
                        >
                            <SiYoutube className="w-7 h-7" />
                        </a>
                        <a
                            href="https://open.spotify.com/artist/1F5DBff89H8ieU4fZzYfWh?si=bJWDxLwZQgy6esjlbwkRgw"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-primary transition-colors"
                        >
                            <SiSpotify className="w-7 h-7" />
                        </a>
                        <a
                            href="https://music.apple.com/us/artist/samuel-john-band/1722021844"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-primary transition-colors"
                        >
                            <SiApplemusic className="w-7 h-7" />
                        </a>
                    </div>
                </div>
            </div>

            {/* Show Schedule */}
            <div className="max-w-6xl mx-auto px-4 py-16 mb-12">
                <h2 className="text-4xl md:text-5xl font-bold uppercase text-primary mb-6">Upcoming Shows</h2>
                <div className="h-1 w-24 bg-primary mb-8"></div>
                <BandsInTownWidget />
            </div>

            {/* Call to Action */}
            <div className="pb-12">
                <ContactCTA className="max-w-4xl" />
            </div>
        </div>
    );
}
